const REMINDER_LOG_PREFIX = "[BFL_REMINDER]";

export function maskMobileNumber(mobileNo?: string | null): string {
  if (!mobileNo) {
    return "NA";
  }

  return `${mobileNo.slice(0, 4)}***`;
}

export function serializeReminderError(error: unknown) {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  return {
    message: typeof error === "string" ? error : "Unknown error",
    rawError: error,
  };
}

export function logReminderInfo(source: string, step: string, context?: Record<string, unknown>) {
  console.log(`${REMINDER_LOG_PREFIX}[${source}] ${step}`, context ?? {});
}

export function logReminderError(
  source: string,
  step: string,
  error: unknown,
  context?: Record<string, unknown>
) {
  console.error(`${REMINDER_LOG_PREFIX}[${source}] ${step}`, {
    ...(context ?? {}),
    error: serializeReminderError(error),
  });
}
